var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1218_6048",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 140
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1218_6048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5407 96.8317L94.499 55.7067V47.54L57.1657 55.7067L44.9157 63.8734L36.749 72.0401L61.5407 96.8317ZM69.7074 128.332C61.6379 128.332 54.0546 126.799 46.9574 123.735C39.8601 120.674 33.6865 116.519 28.4365 111.269C23.1865 106.019 19.0312 99.8456 15.9707 92.7484C12.9062 85.6512 11.374 78.0678 11.374 69.9984C11.374 61.9289 12.9062 54.3456 15.9707 47.2484C19.0312 40.1512 23.1865 33.9775 28.4365 28.7275C33.6865 23.4775 39.8601 19.3203 46.9574 16.2559C54.0546 13.1953 61.6379 11.665 69.7074 11.665C77.7768 11.665 85.3601 13.1953 92.4574 16.2559C99.5546 19.3203 105.728 23.4775 110.978 28.7275C116.228 33.9775 120.383 40.1512 123.444 47.2484C126.508 54.3456 128.041 61.9289 128.041 69.9984C128.041 78.0678 126.508 85.6512 123.444 92.7484C120.383 99.8456 116.228 106.019 110.978 111.269C105.728 116.519 99.5546 120.674 92.4574 123.735C85.3601 126.799 77.7768 128.332 69.7074 128.332Z",
    fill: "#9CD751",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4254 85.0254L88.4554 61.9954L83.882 57.422L65.4254 75.8787L56.1154 66.5687L51.542 71.142L65.4254 85.0254ZM69.9987 102.665C65.4798 102.665 61.2331 101.807 57.2587 100.091C53.2843 98.3773 49.827 96.0504 46.887 93.1104C43.947 90.1704 41.6201 86.7132 39.9062 82.7387C38.1901 78.7643 37.332 74.5176 37.332 69.9987C37.332 65.4798 38.1901 61.2331 39.9062 57.2587C41.6201 53.2843 43.947 49.827 46.887 46.887C49.827 43.947 53.2843 41.619 57.2587 39.9029C61.2331 38.189 65.4798 37.332 69.9987 37.332C74.5176 37.332 78.7643 38.189 82.7387 39.9029C86.7132 41.619 90.1704 43.947 93.1104 46.887C96.0504 49.827 98.3773 53.2843 100.091 57.2587C101.807 61.2331 102.665 65.4798 102.665 69.9987C102.665 74.5176 101.807 78.7643 100.091 82.7387C98.3773 86.7132 96.0504 90.1704 93.1104 93.1104C90.1704 96.0504 86.7132 98.3773 82.7387 100.091C78.7643 101.807 74.5176 102.665 69.9987 102.665Z",
    fill: "#9CD751"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.6a44dd4d74ae11a592d3416841a6bc25.svg";
export { ForwardRef as ReactComponent };